import { render, staticRenderFns } from "./ProcessBatchScreen.vue?vue&type=template&id=2aa220af&scoped=true&"
import script from "./ProcessBatchScreen.vue?vue&type=script&lang=js&"
export * from "./ProcessBatchScreen.vue?vue&type=script&lang=js&"
import style0 from "./ProcessBatchScreen.vue?vue&type=style&index=0&id=2aa220af&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa220af",
  null
  
)

export default component.exports